export default __webpack_public_path__ + "static/media/otp-img.23dadc73.svg";